import React, { useEffect, useState } from "react";
import moment from "moment";
import html2pdf from 'html2pdf.js';
import ReactDOMServer from 'react-dom/server';
import total_protect from "../../src/assets/img/logos/logo Total Protect.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { Spinner } from "../components/Spinner";
import PromisePool from 'es6-promise-pool';

const DocPDFReporteFinalEvento = ({ registroSeguridadEventos, unidadEventSeguridad, numeroUnidad }) => {

    const [imageness, setImagenes] = useState();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            await fileUpload();
            setLoading(false);
        };

        fetchData();
    }, []);

    useEffect(() => {
        return () => {
            if (imageness && imageness.length > 0) {
                imageness.forEach(img => {
                    URL.revokeObjectURL(img.url);
                });
            }
        };
    }, [imageness]);

    const pdfJSX = () => {
        return (
            <>
                {
                    registroSeguridadEventos.map((evt, index) => {
                        if (unidadEventSeguridad && evt.evento_seguridad_id === unidadEventSeguridad) {
                            return (
                                <>
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-6">
                                                <img src={total_protect} alt="total protect" style={{ maxWidth: "200px", maxHeight: "70px", marginTop: "15px" }} />
                                            </div>
                                            <div className="col-6 mt-3">
                                                <h5 className="float-end"><strong>Folio:</strong> {evt.folio} </h5>
                                            </div>
                                            <div className="col-12"><h2 style={{ fontWeight: 'bold' }}>CENTRO DE MONITOREO</h2></div>
                                            <div style={{ fontSize: "12px" }}>
                                                <div className="col-12 mt-3">
                                                    <strong>Fecha de registro: </strong>
                                                    {moment(evt.createdAt).format("lll")}
                                                </div>
                                                <div className="col-12">
                                                    <strong>Monitorista: </strong>
                                                    {evt.usuario.name}
                                                </div>
                                                <div className="col-12 card" style={{ marginTop: "10px" }}>
                                                    <div className="card-header" style={{ textAlign: "center" }}>
                                                        <strong>TIPO DE INCIDENTE: </strong>
                                                        {evt.evento.evento}
                                                    </div>
                                                    <div className="card-body text-secondary">
                                                        <div className="row" style={{ fontSize: "10px" }}>
                                                            <div className="col-12">
                                                                <div className="">
                                                                    <strong>Coordenadas del lugar de evento: </strong> {evt.coordenadas_inicio}
                                                                </div>
                                                            </div>
                                                            <div className="col-12">
                                                                <strong>Ubicación: </strong> {evt.vialidad}
                                                            </div>
                                                            <div className="col-4">
                                                                <strong>Estado: </strong> {evt.estado.entidad_federativa}
                                                            </div>
                                                            <div className="col-4">
                                                                <strong>Alcandía/Municipio: </strong> {evt.municipio.municipio}
                                                            </div>
                                                            <div className="col-4">
                                                                <div className="">
                                                                    {
                                                                        evt.tipo_unidad_id === 1 ? (
                                                                            <>
                                                                                <strong>AS3: </strong>{evt.activacion_as3 ? evt.activacion_as3 : "NO"}
                                                                            </>
                                                                        ) : evt.tipo_unidad_id === 3 ? (
                                                                            <>
                                                                                <strong>AS4: </strong>{evt.activacion_as3 ? evt.activacion_as3 : "NO"}
                                                                            </>
                                                                        ) : ""
                                                                    }
                                                                </div>
                                                            </div>
                                                            {
                                                                evt.tipo_unidad_id === 1 ? (
                                                                    <>
                                                                        <div className="col-4">
                                                                            <div className="">
                                                                                <strong>Chapas de seguridad: </strong> {evt.chapa_seguridad}
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-4">
                                                                            <strong>CCTV:</strong> {evt.cctv === true ? "SI" : "NO"}
                                                                        </div>
                                                                    </>
                                                                ) : ""
                                                            }
                                                            <div className="col-4">
                                                                <strong>Paro de motor: </strong> {evt.paro_motor === 0 ? "NO" : "SI"}
                                                            </div>
                                                            <div className="col-12">
                                                                <div className="">
                                                                    <strong>Modus operandi: </strong> {evt.modus_operandi}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12 card" style={{ marginTop: "10px" }}>
                                                    <div className="card-header" style={{ textAlign: "center" }}>
                                                        <strong>DATOS DE LA UNIDAD: </strong>
                                                    </div>
                                                    <div className="card-body text-secondary">
                                                        <div className="row" style={{ fontSize: "10px" }}>
                                                            <div className="col-4">
                                                                <div className="">
                                                                    <strong>Placas:</strong> {
                                                                        evt.tipo_unidad_id === 1 ?
                                                                            evt.unidad.unidad_placas :
                                                                            evt.unidad.unidad_placas
                                                                    }
                                                                </div>
                                                                <div className="">
                                                                    <strong>Serie:</strong> {
                                                                        evt.tipo_unidad_id === 1 ?
                                                                            evt.unidad.unidad_vin :
                                                                            evt.unidad.unidad_vin
                                                                    }
                                                                </div>
                                                            </div>
                                                            <div className="col-4">
                                                                <div className="">
                                                                    <strong>Marca:</strong> {
                                                                        evt.tipo_unidad_id === 1 ?
                                                                            evt.unidad.unidad_marca :
                                                                            evt.unidad.unidad_marca
                                                                    }
                                                                </div>
                                                                <div className="">
                                                                    <strong>Submarca:</strong> {
                                                                        evt.tipo_unidad_id === 1 ?
                                                                            evt.unidad.unidad_modelo :
                                                                            evt.unidad.unidad_submarca
                                                                    }
                                                                </div>
                                                            </div>
                                                            <div className="col-4">
                                                                <div className="">
                                                                    <strong>Color:</strong> {
                                                                        evt.tipo_unidad_id === 1 ?
                                                                            evt.unidad.unidad_color :
                                                                            evt.unidad.unidad_color
                                                                    }
                                                                </div>
                                                                {
                                                                    evt.tipo_unidad_id === 1 ? (
                                                                        <>
                                                                            <div className="">
                                                                                <strong>Económico:</strong>
                                                                                {evt.unidad.unidad_numero}
                                                                            </div>
                                                                        </>
                                                                    ) : ""
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {
                                                    evt.cajas?.length > 0 && (
                                                        <div className="col-12 card" style={{ marginTop: "10px" }}>
                                                            <div className="card-header" style={{ textAlign: "center" }}>
                                                                <strong>DATOS DE CAJAS</strong>
                                                            </div>

                                                            <div className="card-body text-secondary">
                                                                {
                                                                    evt.cajas.map((caja, index) => (
                                                                        <div
                                                                            key={caja.unidad_id || index}
                                                                            className="row"
                                                                            style={{
                                                                                fontSize: "10px",
                                                                                marginBottom: "10px",
                                                                                borderBottom:
                                                                                    index < evt.cajas.length - 1
                                                                                        ? "1px solid #ddd"
                                                                                        : "none",
                                                                                paddingBottom: "10px"
                                                                            }}
                                                                        >
                                                                            <div className="col-12">
                                                                                <strong>
                                                                                    Caja {index + 1}
                                                                                </strong>
                                                                            </div>

                                                                            <div className="col-4">
                                                                                <div>
                                                                                    <strong>Placas:</strong> {caja.placas}
                                                                                </div>
                                                                                <div>
                                                                                    <strong>Serie:</strong> {caja.serie}
                                                                                </div>
                                                                            </div>

                                                                            <div className="col-4">
                                                                                <div>
                                                                                    <strong>Marca:</strong> {caja.marca}
                                                                                </div>
                                                                                <div>
                                                                                    <strong>Submarca:</strong> {caja.submarca || "N/A"}
                                                                                </div>
                                                                            </div>

                                                                            <div className="col-4">
                                                                                <div>
                                                                                    <strong>Modelo:</strong> {caja.modelo}
                                                                                </div>
                                                                                <div>
                                                                                    <strong>Económico:</strong> {caja.economico}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))
                                                                }
                                                            </div>
                                                        </div>
                                                    )
                                                }

                                                <div className="col-12 card" style={{ marginTop: "10px" }}>
                                                    <div className="card-header" style={{ textAlign: "center" }}>
                                                        <strong>DATOS DEL SEGUIMIENTO DEL EVENTO </strong>
                                                    </div>
                                                    <div className="card-body text-secondary">
                                                        <div className="row" style={{ fontSize: "10px" }}>
                                                            {
                                                                evt.tipo_unidad_id === 1 ? (
                                                                    <>
                                                                        <div className="col-8">
                                                                            <div className="pt-2">
                                                                                <strong>Negocio: </strong>{evt.unidad.negocio.negocio_nombre}
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-4">
                                                                            <div className="pt-2">
                                                                                <strong>Cedis:</strong> {evt.unidad.cedi.nombre_cedis}
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-8">
                                                                            <div className="pt-2">
                                                                                <strong>Operador: </strong>
                                                                                {
                                                                                    evt.tripulantes.chofer.nombre_completo !== null ? (
                                                                                        evt.tripulantes.chofer.nombre_completo + "     "
                                                                                    ) : ""}
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-4">
                                                                            <div className="pt-2">
                                                                                <strong>Teléfono: </strong>
                                                                                {
                                                                                    evt.tripulantes.chofer.telefono !== null ? (
                                                                                        evt.tripulantes.chofer.telefono
                                                                                    ) : ""
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                        {
                                                                            evt.tripulantes?.tripulacion?.map((tripulante, index) => (
                                                                                <React.Fragment key={tripulante.tripulante_id || index}>
                                                                                    <div className="col-8">
                                                                                        <div className="pt-2">
                                                                                            <strong>
                                                                                                {index === 0 ? "Tripulante:" : "Tripulante " + (index + 1) + ":"}
                                                                                            </strong>{" "}
                                                                                            {tripulante.nombre_completo}
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className="col-4">
                                                                                        <div className="pt-2">
                                                                                            <strong>Teléfono: </strong>
                                                                                            {tripulante.telefono}
                                                                                        </div>
                                                                                    </div>
                                                                                </React.Fragment>
                                                                            ))
                                                                        }
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <div className="col-4">
                                                                            <div className="pt-2">
                                                                                <strong>Usuario: </strong>
                                                                                {evt.unidad.cliente_gestor ? evt.unidad.cliente_gestor : ""}
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-4">
                                                                            <div className="pt-2">
                                                                                <strong>Cliente: </strong>
                                                                                {evt.unidad.cliente_gestor ? evt.unidad.cliente : ""}
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-4">
                                                                            <div className="pt-2">
                                                                                <strong>Teléfono: </strong>
                                                                                {evt.unidad.cliente_gestor_telefono !== null ? (evt.unidad.cliente_gestor_telefono) : ""}
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )
                                                            }
                                                            <div className="col-4">
                                                                <div className="pt-2">
                                                                    <strong>Predenuncia:</strong> {evt.predenuncia}
                                                                </div>
                                                            </div>
                                                            <div className="col-4 pt-2">
                                                                <strong>Carpeta de investigación:</strong> {evt.carpeta_investigacion}
                                                            </div>
                                                            {
                                                                evt.tipo_unidad_id === 1 ? (
                                                                    <>
                                                                        <div className="col-4 pt-2">
                                                                            <strong>Chapas de seguridad:</strong> {evt.chapa_seguridad}
                                                                        </div>
                                                                    </>
                                                                ) : ""
                                                            }

                                                            {
                                                                evt.tipo_unidad_id === 1 ? (
                                                                    <>
                                                                        <div className="col-4 pt-2">
                                                                            <strong>AS3:</strong> {evt.activacion_as3}
                                                                        </div>
                                                                    </>
                                                                ) : ""
                                                            }

                                                            {
                                                                evt.tipo_unidad_id === 1 ? (
                                                                    <>
                                                                        <div className="col-4 pt-2">
                                                                            <strong>CCTV:</strong> {evt.cctv === true ? "SI" : "NO"}
                                                                        </div>
                                                                    </>
                                                                ) : ""
                                                            }

                                                            {
                                                                evt.tipo_unidad_id !== 1 ? (
                                                                    <>
                                                                        <div className="col-4 pt-2">
                                                                            <strong>GPS reportando:</strong> {evt.gps_reportando === true ? "SI" : evt.gps_reportando === 1 ? "SI" : "NO"}
                                                                        </div>
                                                                    </>
                                                                ) : ""
                                                            }

                                                        </div>
                                                    </div>
                                                </div>
                                                {
                                                    evt.registro_evento_seguridads.map((seguimiento, index) => {
                                                        return (
                                                            <>
                                                                <div className="card mt-3" style={{ breakInside: "avoid-page", marginTop: "5px" }}>
                                                                    <ul className="list-group list-group-flush" style={{ fontSize: "10px" }}>
                                                                        <li className="list-group-item">
                                                                            <div className="row">
                                                                                <div className="col-4">
                                                                                    <strong>Estatus</strong>
                                                                                </div>
                                                                                <div className="col-8">
                                                                                    {seguimiento.estatus_evento.estatus_evento}
                                                                                </div>
                                                                            </div>
                                                                        </li>
                                                                        {
                                                                            index !== 0 ? (
                                                                                <>
                                                                                    <li className="list-group-item">
                                                                                        <div className="row">
                                                                                            <div className="col-4">
                                                                                                <strong>Fecha de actualización</strong>
                                                                                            </div>
                                                                                            <div className="col-8">
                                                                                                {moment(seguimiento.updatedAt).format("lll")}
                                                                                            </div>
                                                                                        </div>
                                                                                    </li>
                                                                                    {
                                                                                        seguimiento.tipo_apoyo_riesgos.length !== 0 ? (
                                                                                            <li className="list-group-item">
                                                                                                <div className="row">
                                                                                                    <div className="col-4">
                                                                                                        <strong>Tipos de apoyo</strong>
                                                                                                    </div>
                                                                                                    <div className="col-8">
                                                                                                        {
                                                                                                            seguimiento.tipo_apoyo_riesgos.map((apoyo, index) => {
                                                                                                                return (
                                                                                                                    <>
                                                                                                                        {apoyo.apoyo_tipo.apoyo_tipo + ", "}
                                                                                                                    </>
                                                                                                                )
                                                                                                            })
                                                                                                        }
                                                                                                    </div>
                                                                                                </div>
                                                                                            </li>
                                                                                        ) : ""
                                                                                    }

                                                                                    {
                                                                                        seguimiento.lugar ? (
                                                                                            <li className="list-group-item">
                                                                                                <div className="row">
                                                                                                    <div className="col-4">
                                                                                                        <strong>Lugar remitido</strong>
                                                                                                    </div>
                                                                                                    <div className="col-8">
                                                                                                        {seguimiento.lugar}
                                                                                                    </div>
                                                                                                </div>
                                                                                            </li>
                                                                                        ) : ""
                                                                                    }

                                                                                </>
                                                                            ) : (
                                                                                <>
                                                                                    <li className="list-group-item">
                                                                                        <div className="row">
                                                                                            <div className="col-4">
                                                                                                <strong>Fecha de registro</strong>
                                                                                            </div>
                                                                                            <div className="col-8">
                                                                                                {moment(seguimiento.updatedAt).format("lll")}
                                                                                            </div>
                                                                                        </div>
                                                                                    </li>
                                                                                </>
                                                                            )
                                                                        }
                                                                        {
                                                                            index === 0 ? (
                                                                                <li className="list-group-item">
                                                                                    <div className="row">
                                                                                        <div className="col-4">
                                                                                            <strong>Coordenadas de inicio de evento</strong>
                                                                                        </div>
                                                                                        <div className="col-8">
                                                                                            {evt.coordenadas_inicio}
                                                                                        </div>
                                                                                    </div>
                                                                                </li>
                                                                            ) : index !== 0 && seguimiento.coordenadas ? (
                                                                                <li className="list-group-item">
                                                                                    <div className="row">
                                                                                        <div className="col-4">
                                                                                            <strong>Coordenadas de seguimiento</strong>
                                                                                        </div>
                                                                                        <div className="col-8">
                                                                                            {seguimiento.coordenadas}
                                                                                        </div>
                                                                                    </div>
                                                                                </li>
                                                                            ) : ""
                                                                        }
                                                                        {
                                                                            seguimiento.observaciones ? (
                                                                                <li className="list-group-item">
                                                                                    <div className="row">
                                                                                        <div className="col-4">
                                                                                            <strong>Observaciones</strong>
                                                                                        </div>
                                                                                        <div className="col-8">
                                                                                            {seguimiento.observaciones}
                                                                                        </div>
                                                                                    </div>
                                                                                </li>
                                                                            ) : ""
                                                                        }

                                                                        {
                                                                            index === 0 ? (
                                                                                <>
                                                                                    <li className="list-group-item">
                                                                                        <div className="row">
                                                                                            <div className="col-4">
                                                                                                <strong>Registro de evento por:</strong>
                                                                                            </div>
                                                                                            <div className="col-8">
                                                                                                {seguimiento.usuario.name}
                                                                                            </div>
                                                                                        </div>
                                                                                    </li>
                                                                                </>
                                                                            ) : index !== 0 ? (
                                                                                <>
                                                                                    <li className="list-group-item">
                                                                                        <div className="row">
                                                                                            <div className="col-4">
                                                                                                <strong>Seguimiento de evento por:</strong>
                                                                                            </div>
                                                                                            <div className="col-8">
                                                                                                {seguimiento.usuario.name}
                                                                                            </div>
                                                                                        </div>
                                                                                    </li>
                                                                                </>
                                                                            ) : ""
                                                                        }

                                                                    </ul>
                                                                </div>
                                                            </>
                                                        )
                                                    })
                                                }
                                            </div>
                                            {
                                                imageness ? (
                                                    <div style={{ textAlign: "center" }} className="mt-3">
                                                        <strong>EVIDENCIA FOTOGRÁFICA</strong>
                                                    </div>
                                                ) : ""
                                            }
                                            {
                                                imageness ? (
                                                    imageness.map((img) => {
                                                        return (
                                                            <>
                                                                <div style={{ breakInside: "avoid-page", height: "1000px", alignItems: "center", justifyContent: "center", display: "flex" }}>

                                                                    <img
                                                                        style={{ height: "700px", width: "90%" }}
                                                                        src={img.url}
                                                                        alt="Evidencia"
                                                                    />
                                                                </div>
                                                            </>
                                                        );
                                                    })
                                                ) : ""
                                            }
                                        </div>
                                    </div>
                                </>
                            )
                        }
                    })
                }
            </>
        )
    }

    const fileUpload = async () => {
        const arr = [];

        // Filtra eventos según unidad
        const eventos = registroSeguridadEventos.filter(evt =>
            unidadEventSeguridad && evt.evento_seguridad_id === unidadEventSeguridad
        );

        // Obtén todos los seguimientos de esos eventos
        let seguimientoList = eventos.flatMap(evt => evt.registro_evento_seguridads);

        // Aquí filtramos solo aquellos que tengan URL no nula y con contenido (ejemplo: que no sea "")
        seguimientoList = seguimientoList.filter(seguimiento => seguimiento.url && seguimiento.url.trim() !== "");

        let i = 0;

        const promiseProducer = () => {
            if (i >= seguimientoList.length) return null;

            const seguimiento = seguimientoList[i++];
            // Aquí usas el registro_evento_id para armar la url de la petición
            const url = `${process.env.REACT_APP_API_URL_LOCAL}eventos-seguridad/download/${seguimiento.registro_evento_id}`;

            return axios.get(url, { responseType: 'blob' })
                .then(res => {
                    const imgUrl = URL.createObjectURL(res.data);
                    arr.push({ url: imgUrl });
                })
                .catch(err => {
                    if ((err.response && err.response.status) && err.response.status === 400) {
                        console.log("archivo no encontrado");
                    } else {
                        console.error("error: " + err);
                    }
                });
        };

        const pool = new PromisePool(promiseProducer, 3);
        await pool.start();

        setImagenes(arr);
    };



    const printHandler = (e) => {
        e.preventDefault();
        setLoading(true);
        const printElement = ReactDOMServer.renderToString(pdfJSX());
        const options = {
            filename: `EVENTO DE SEGURIDAD ${numeroUnidad}.pdf`,
            margin: 0.2,
            image: { type: 'jpeg', quality: 0.98 },
            // pagebreak:{ mode: 'avoid-all', before: 'img', after: "1cm" },  //{ mode: "css", before: "img", after: "1cm" },
            // html2canvas: { scale: 2 },
            jsPDF: {
                unit: 'in',
                format: 'letter',
                orientation: 'portrait',
            },
        };

        html2pdf().set(options).from(printElement).save();
        setLoading(false);
    }

    return (
        <>
            {loading && <Spinner />}
            <a>
                <FontAwesomeIcon
                    icon={faFilePdf}
                    onClick={(e) => (printHandler(e))}
                    style={{ fontSize: "35px", color: "chocolate", margin: "0 25px" }}
                />
            </a>
        </>
    );
}

export default DocPDFReporteFinalEvento;